/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, {Component} from 'react';
import {InputNumber, Input} from 'antd';
import { debounce } from 'lodash';

class InputNumberlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            select2options: [],
            special_request_comment: null
        };
        // this.processChange = this.processChange.bind(this);
        this.handleChange =this.handleChange.bind(this);
    }
    componentDidMount() {
        // console.log(this.props.selectdata);
        // console.log(this.props.Queuedata);
    }
    processChange = (event) => {
        event.persist();
        if (!this.debouncedFn) {
            this.debouncedFn = debounce(() => {
                this.handleChange(event);
            }, 500);
        }
        this.debouncedFn();
    }

    handleChange(event) {
        console.log(`selected ${event}`); 
    let event_value = event !== null && event !== undefined && !isNaN(event) ? parseInt(event) : 0;
            if (this.props.selectdata.name === 'price' || this.props.selectdata.name === 'percentage' || this.props.selectdata.name === 'qty' || this.props.selectdata.name === 'rate' || this.props.selectdata.name === 'amount') {
                let event_value = event?parseInt(event):event;
                    if (event_value >= 0 && Number.isInteger(event_value)) {
                        this.props.onInputChanges({
                            id: this.props.selectdata.id,
                            name: this.props.selectdata.name,
                            // value: event,
                            value: event_value,
                            row: this.props.selectdata.row_group,
                            table: this.props.selectdata.table,
                            tableName: this.props.selectdata.table,
                            parentID: this.props.selectdata.pid,
                            header: this.props.selectdata.header ? this.props.selectdata.header : null,
                            sub_header: this.props.selectdata.sub_header ? this.props.selectdata.sub_header : null,
                            element:'input'
                        });
                    } else {
                        // this.inputRef.value = null;
                        if (this.inputRef.current) {
                            this.inputRef.current.value = null;
                        }
                        
                        this.props.onInputChanges({
                            id: this.props.selectdata.id,
                            name: this.props.selectdata.name,
                            value: 0,
                            row: this.props.selectdata.row_group,
                            table: this.props.selectdata.table,
                            tableName: this.props.selectdata.table,
                            parentID: this.props.selectdata.pid,
                            header: this.props.selectdata.header ? this.props.selectdata.header : null,
                            sub_header: this.props.selectdata.sub_header ? this.props.selectdata.sub_header : null,
                            element:'input'
                        });
                    }
        }else{        
            this.props.onInputChanges({
                id: this.props.selectdata.id,
                name: this.props.selectdata.name,
                // value: event,
                value: event_value,
                row: this.props.selectdata.row_group,
                table: this.props.selectdata.table,
                tableName: this.props.selectdata.table,
                parentID: this.props.selectdata.pid,
                header: this.props.selectdata.header ? this.props.selectdata.header : null,
                sub_header: this.props.selectdata.sub_header ? this.props.selectdata.sub_header : null,
                element:'input'
            });
        }
    }
    
    onSpecialRequestComment(text) {
        console.log("selected event_value:",text, this.props);

        // this.inputRef.value = null;
        this.setState({ special_request_comment: text }, () => {
            this.props.table_body.map((itemData) => {
                this.props.onInputChanges({
                    id: this.props.selectdata.id,
                    name: this.props.selectdata.name,
                    value: text,
                    row: this.props.selectdata.row_group,
                    table: this.props.selectdata.table,
                    tableName: this.props.selectdata.table,
                    parentID: this.props.selectdata.pid,
                    header: this.props.selectdata.header ? this.props.selectdata.header : null,
                    sub_header: this.props.selectdata.sub_header ? this.props.selectdata.sub_header : null,
                    keyword: itemData.key_word, 
                    element: 'input'
                });
            });
        });
    }

    onChange(value) {
        let event_value = value !== null && value !== undefined && !isNaN(value) ? value : 0;
            if (this.props.selectdata.name === 'lower_limit' || this.props.selectdata.name === 'upper_limit' || this.props.selectdata.name === 'qty' || this.props.selectdata.name === 'percentage') {
                // let event_value = value;
                let event_value = event_value;
                if (event_value >= 0 && Number.isInteger(event_value)) {         
                    // this.props.onselectChanges({id: this.props.selectdata.name, value: value,           
                    this.props.onselectChanges({id: this.props.selectdata.name, value: event_value, 
                        parrentMode: this.props.selectdata.parrentMode, parrentName: this.props.selectdata.parrentName});

                } else {
                    this.inputRef.value = null;                
                    this.props.onselectChanges({id: this.props.selectdata.name, value: 0, 
                            parrentMode: this.props.selectdata.parrentMode, parrentName: this.props.selectdata.parrentName});
                }
            }else{   
                // this.props.onselectChanges({id: this.props.selectdata.name, value: value, 
                this.props.onselectChanges({id: this.props.selectdata.name, value: event_value, 
                        parrentMode: this.props.selectdata.parrentMode, parrentName: this.props.selectdata.parrentName});

            }
        }

    render() {
        const { selectdata } = this.props;
        let {special_request_comment} = this.state;
        const isNumberField = ['price', 'percentage', 'qty', 'rate', 'amount', 'lower_limit', 'upper_limit'].includes(this.props.selectdata.name);
        return (
            selectdata.tableName !== '' ?
            <div className="">
                {isNumberField ? (
                // <InputNumber
                //     // ref={(inputRef => (this.inputRef = inputRef))}
                //     disabled={selectdata.disable}
                //     onChange={this.handleChange}
                //     placeholder={selectdata.placeholder}
                //     value={selectdata.value !== undefined ? selectdata.value : null}
                //     formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                //     min={0}
                // />
                <InputNumber
                    ref={(inputRef) => (this.inputRef = inputRef)}
                    disabled={selectdata.disable}
                    onChange={this.handleChange} // Call handleChange properly
                    placeholder={selectdata.placeholder}
                    value={selectdata.value !== null && selectdata.value !== undefined ? selectdata.value : 0} // Ensure value is always 0 when cleared
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    min={0}
                />
            ) : (
                <Input
                    // ref={(inputRef => (this.inputRef = inputRef))}
                    disabled={selectdata.disable}
                    onChange={(event) => this.onSpecialRequestComment(event.target.value)}
                    placeholder={selectdata.placeholder}
                    value={special_request_comment !== null ? special_request_comment : selectdata.value}
                />
            )}
            </div>
            :
            <div className="form-group my-4">
                <InputNumber
                    ref={(inputRef =>(this.inputRef = inputRef))}
                    disabled={selectdata.disable}
                    onChange={this.onChange.bind(this)}
                    // onKeyUp={this.processChange.bind(this)}
                    // onKeyUp={this.processChange}
                    placeholder={selectdata.placeholder}
                    value = {selectdata.value}
                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    min={1}/>
            </div>
        );
    }
}

export default InputNumberlayer;
